module.exports = __webpack_public_path__ + "img/xiong.5280406d.jpg";